import { render, staticRenderFns } from "./channelOpe3.vue?vue&type=template&id=da1c9f60&scoped=true&"
import script from "./channelOpe3.vue?vue&type=script&lang=js&"
export * from "./channelOpe3.vue?vue&type=script&lang=js&"
import style0 from "./channelOpe3.vue?vue&type=style&index=0&id=da1c9f60&lang=scss&scoped=true&"
import style1 from "./channelOpe3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1c9f60",
  null
  
)

export default component.exports